import Mapbox from './mapbox';
import Pelias from './pelias';

const Providers = {
  Mapbox,
  Pelias,
};
export default Providers;
